import React from 'react';
import { IconEeckmanLogo } from 'arteia-js/components/Icons';

const Popup = ({
    children,
    loading, loadingComponent,
    className = '', visible = true,
}) => (
    visible
        ? <div className={`${className} popup-window popup-size-form`}>
            <div className="logo-wrapper">
                <div className="art-logo">
                    <IconEeckmanLogo />
                </div>
            </div>
            {loading && loadingComponent}
            {!loading && children}
        </div>
        : null

);

export default Popup;



// WEBPACK FOOTER //
// ./src/arteia-js/components/Popup/index.js